import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../helpers/web_to_client'
import { isChineseLanguage } from '../../helpers/locale.js'

import styles from './Back.css'

const BACK_TYPES = [
    'back',
    'info',
    'close',
    'forward',
]

const BACK_SIDES = [
    'right',
    'left',
]

class Back extends React.PureComponent {
    static propTypes = {
        caption: PropTypes.node.isRequired,
        goto: PropTypes.node,
        type: PropTypes.oneOf(BACK_TYPES).isRequired,
        side: PropTypes.oneOf(BACK_SIDES).isRequired,
        onClick: PropTypes.func.isRequired,
        tooltipId: PropTypes.string,
        tabIndex: PropTypes.number,
    }

    render() {
        const sideClass = this.props.caption ? styles[`base__${this.props.side}`] : null

        const classNameBase = classNames(styles.base, styles[`base__${this.props.type}`], sideClass, {
            [styles.base__chinese]: isChineseLanguage(),
        })

        const goto = this.props.goto ? (
            <span className={styles.goto}>{this.props.goto}</span>
        ) : null

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        const tabIndexAttr = this.props.tabIndex !== undefined ? {
            tabIndex: this.props.tabIndex,
        } : {}

        return (
            <button
                className={classNameBase}
                onClick={this.props.onClick}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
                {...tabIndexAttr}
                {...dataAttrs}
            >
                <span className={styles.icon} />
                <span className={styles.caption}>
                    {this.props.caption}
                </span>
                {goto}
            </button>
        )
    }
}

export default Back



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Back/Back.jsx